import Box from '@material-ui/core/Box'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import MenuIcon from '@material-ui/icons/Menu'
import { makeStyles } from '@material-ui/styles'
import { usePageContext } from 'components/PageContext'
import { Link } from 'gatsby'
import {
  bindPopover,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'inline-block',
    padding: '22px',
    fontFamily: 'Open Sans',
    fontWeight: '700',
    fontSize: '0.82rem',
    letterSpacing: '0.48px',
    textDecoration: 'none',
    textTransform: 'uppercase',
    color: '#000000'
  },
  activeLink: {
    color: `${theme.palette.text.inactive} !important`,
    [theme.breakpoints.down('sm')]: {
      color: '#000000 !important',
      backgroundColor: '#ffd100'
    }
  }
}))

const LinkList = ({ slug, classes }) => (
  <>
    <Box
      bgcolor={{ xs: '#ffffff' }}
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      justifyContent="space-evenly"
      py={1}
    >
      <Link
        activeClassName={classes.activeLink}
        className={classes.link}
        to={`${slug}`}
      >
        Startseite
      </Link>
      <Link
        activeClassName={classes.activeLink}
        className={classes.link}
        to={`${slug}unterrichtsplan`}
      >
        Unterrichtsplan
      </Link>
      <Link
        activeClassName={classes.activeLink}
        className={classes.link}
        to={`${slug}bildergalerie`}
      >
        Bildergalerie
      </Link>
      <Link
        activeClassName={classes.activeLink}
        className={classes.link}
        to={`${slug}termine`}
      >
        Termine
      </Link>
      <Link
        activeClassName={classes.activeLink}
        className={classes.link}
        to={`${slug}berichte`}
      >
        Berichte
      </Link>
      <Link
        activeClassName={classes.activeLink}
        className={classes.link}
        to={`${slug}dantraeger`}
      >
        Danträger
      </Link>
    </Box>
  </>
)

export default () => {
  const classes = useStyles()
  const context = usePageContext()
  const {
    page: { full_slug }
  } = context
  const slug = full_slug?.match(/standort(\/.*\/)/)[1]

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'demoPopover'
  })

  return (
    <Box boxShadow={3}>
      <Hidden smDown>
        <LinkList classes={classes} slug={slug} />
      </Hidden>

      <Hidden mdUp>
        <Box bgcolor="#ffffff">
          <Box textAlign="center" width="100vw" {...bindTrigger(popupState)}>
            <IconButton aria-label="Menu" color="inherit">
              <MenuIcon color="text.primary" />
            </IconButton>
          </Box>

          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <LinkList classes={classes} slug={slug} />
          </Popover>
        </Box>
      </Hidden>
    </Box>
  )
}
